var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_1139)",
    filter: "url(#filter0_d_422_1139)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_422_1139)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_422_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 1.66663C12.3512 1.66663 10.74 2.15537 9.3696 3.07105C7.99919 3.98672 6.93109 5.28821 6.30036 6.81093C5.66963 8.33365 5.5046 10.0092 5.82614 11.6257C6.14769 13.2422 6.94136 14.7271 8.1068 15.8925C9.27223 17.058 10.7571 17.8516 12.3736 18.1732C13.9901 18.4947 15.6657 18.3297 17.1884 17.699C18.7111 17.0682 20.0126 16.0001 20.9283 14.6297C21.8439 13.2593 22.3327 11.6481 22.3327 9.99996C22.3327 8.90561 22.1171 7.82198 21.6983 6.81093C21.2796 5.79988 20.6657 4.88122 19.8919 4.1074C19.1181 3.33358 18.1994 2.71975 17.1884 2.30096C16.1773 1.88217 15.0937 1.66663 13.9994 1.66663ZM18.166 8.23329L13.4494 12.95C13.2941 13.1039 13.0846 13.1907 12.866 13.1916C12.7563 13.1923 12.6476 13.1712 12.5461 13.1298C12.4446 13.0883 12.3522 13.0272 12.2744 12.95L9.87435 10.5916C9.79625 10.5142 9.73425 10.422 9.69194 10.3204C9.64964 10.2189 9.62785 10.11 9.62785 9.99996C9.62785 9.88995 9.64964 9.78103 9.69194 9.67948C9.73425 9.57793 9.79625 9.48576 9.87435 9.40829C10.0305 9.25308 10.2417 9.16597 10.4619 9.16597C10.682 9.16597 10.8932 9.25308 11.0494 9.40829L12.8244 11.175L16.9494 7.04996C17.1055 6.89475 17.3167 6.80763 17.5369 6.80763C17.757 6.80763 17.9682 6.89475 18.1244 7.04996C18.2052 7.12464 18.2705 7.21461 18.3165 7.31468C18.3624 7.41474 18.388 7.52291 18.3919 7.63294C18.3958 7.74297 18.3778 7.85267 18.339 7.95572C18.3003 8.05876 18.2415 8.15311 18.166 8.23329Z",
    fill: "#18AA29"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_422_1139",
    x: 0,
    y: 0,
    width: 28,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_1139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_1139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_422_1139",
    x: 1.66602,
    y: 1.66663,
    width: 24.666,
    height: 24.6666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_1139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_1139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_422_1139",
    x: 1.66602,
    y: 1.66663,
    width: 24.666,
    height: 24.6666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_1139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_1139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_1139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 25,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/completeIcon.d8c3908008a1ac6f08417695d5e4395f.svg";
export { ForwardRef as ReactComponent };